import Image from 'next/legacy/image'
import { storyblokImageLoader } from '@cinch-nx/data-storyblok'

import styles from './hero-image.module.css'
import type { HomeHeroV2 } from '../../../types/home-story-content'
import cx from 'classnames'

export function HeroImage({
  isMobileImageShown,
  image,
  storyFallback = false,
}: {
  isMobileImageShown: boolean
  image: HomeHeroV2['image']
  storyFallback?: boolean
}) {
  return (
    <div
      className={cx(styles['imageContainer'], {
        [styles['isShownOnMobile']]: isMobileImageShown,
      })}
    >
      <Image
        src={image.filename}
        alt={image.alt ?? 'Hero Image'}
        loader={storyFallback ? undefined : storyblokImageLoader}
        priority={true}
        layout="fill"
        objectFit="contain"
      />
    </div>
  )
}
